import { _request,APIBasePaginatedResponse, APIBaseResponse, APIMethod } from '..';
import { buildQueryParams } from '../apiHelpers';
import { PaginatedRequestParamsBase } from '../Models/CommonRequestModels';

const USERS_PROFILE_PATH_PREFIX = '/profiles/users';
const USERS_PATH_PREFIX = '/users';

export interface IUser {
    id: string;
    oasysId?: string;
    profile: {
        firstName: string;
        lastName: string;
        principalName: string;
        companyKey: string;
        email: string;
    },
    identities?: {
        subject: string;
        issuer: string;
        profile?: {
            firstName?: string;
            lastName?: string;
            email?: string;
            companyKey?: string;
        }
    }[]
}

export type APIUsersGetListParams = PaginatedRequestParamsBase & {
    rowsCount?: number;
    retries?: number;
};

export type APIUserGetListResponse = APIBasePaginatedResponse<Array<IUser>>;

export const APIUsersGet: APIMethod<APIUsersGetListParams, APIUserGetListResponse> = params => {
    const queryParams = buildQueryParams(params);
    const requestPath = `${USERS_PROFILE_PATH_PREFIX}` + (queryParams && `?${queryParams}`);
    return _request('GET', requestPath, undefined, params.signal, params.retries);
};

export type APIUsersPostParams = {
    issuer: string;
    subject?: string;
    billingSystemId?: string;
    profile: {
        firstName?: string;
        lastName?: string;
        email?: string;
        companyKey?: string;
    }
};

type APIUsersPostResponse = APIBaseResponse<{
    userId: string;
}>;

export const APIUsersPost: APIMethod<APIUsersPostParams, APIUsersPostResponse> = params => (
    _request(
        'POST',
        `${USERS_PROFILE_PATH_PREFIX}`,
        params)
);

export type APIUsersGetSingleParams = {
    userId: string;
}

export type APIUsersGetSingleResponse = APIBaseResponse<IUser>;

export const APIUserGetSingle: APIMethod<APIUsersGetSingleParams, APIUsersGetSingleResponse> = (params: APIUsersGetSingleParams) => (
    _request('GET', `${USERS_PROFILE_PATH_PREFIX}/${params.userId}`)
);

export type APIUserPatchParams = {
    userId: string;
    billingSystemId?: string;
    identity: {
        issuer: string;
        subject: string;
        profile?: {
            firstName: string;
            lastName: string;
            email: string;
            companyKey: string;
        }
    }
};

export const APIUserPatch: APIMethod<APIUserPatchParams, APIBaseResponse> = params => (
    _request('PATCH', `${USERS_PROFILE_PATH_PREFIX}/${params.userId}`, { ...params.identity, billingSystemId: params.billingSystemId })
);

export type APIUserIdentityDeleteParams = {
    userId: string;
    issuer: string;
    subject: string;
};

export const APIUserDeleteIdentity: APIMethod<APIUserIdentityDeleteParams, APIBaseResponse> = params => (
    _request('DELETE', `${USERS_PATH_PREFIX}/${params.userId}?issuer=${params.issuer}&subject=${params.subject}`)
);

export type APIUserDeleteParams = {
    userId: string;
};

export const APIUserDelete: APIMethod<APIUserDeleteParams, APIBaseResponse> = params => (
    _request('DELETE', `${USERS_PATH_PREFIX}/${params.userId}`)
);
